// extracted by mini-css-extract-plugin
export default {"course-gain":"CourseGain_course-gain__ppwlW"};